import { render, staticRenderFns } from "./DayInfo.vue?vue&type=template&id=028afcda"
import script from "./DayInfo.vue?vue&type=script&lang=js"
export * from "./DayInfo.vue?vue&type=script&lang=js"
import style0 from "./DayInfo.vue?vue&type=style&index=0&id=028afcda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports